import { formatNumber } from "./HelperFunctions";

type Source = { [key: string]: any } | null | undefined;

export type CompanyContacts = { name: string; phone: string; email: string };

const text = (value: unknown): string =>
  typeof value === "string" ? value.trim() : "";

// get-portal-company-markers sends the email as a mailto link.
const stripHtml = (value: unknown): string =>
  text(value)
    .replace(/<[^>]*>/g, "")
    .trim();

/**
 * The company's own name, support phone and support email for the agreement
 * screens: the company details the page footer shows, else the company markers
 * (which also load for a customer opening the emailed link signed out). Never
 * DCDial's: an empty value means "not known", and the caller leaves it out
 * instead of printing a blank like "call us at +1 ." (CP-887).
 */
export const getCompanyContacts = ({
  companyDetails,
  companyMarkers,
}: {
  companyDetails?: Source;
  companyMarkers?: Source;
}): CompanyContacts => {
  const detailsPhone = text(companyDetails?.phone_number);
  // formatNumber turns an empty number into "+1 ", which reads as a value.
  const formattedDetailsPhone = detailsPhone
    ? text(
        formatNumber(detailsPhone, companyDetails?.countryCode || "1", true)
      )
    : "";
  const markerPhone = stripHtml(companyMarkers?.["Support Phone"]);
  // The marker is the US national form, "(404) 410-2799".
  const formattedMarkerPhone =
    markerPhone.replace(/\D/g, "").length === 10
      ? `+1 ${markerPhone}`
      : markerPhone;

  return {
    name:
      text(companyDetails?.name) ||
      text(companyDetails?.company_name) ||
      text(companyMarkers?.["Company Name"]),
    phone:
      formattedDetailsPhone.replace(/\D/g, "").length > 1
        ? formattedDetailsPhone
        : formattedMarkerPhone,
    email:
      text(companyDetails?.email) || stripHtml(companyMarkers?.["Support Email"]),
  };
};
